// GENERATED — DO NOT EDIT.
// Regenerate: cd backend && npm run gen:shared-enums

export const FlowType = {
  NORMAL: 'normal',
  ASCENSUS: 'ascensus',
  SSAB: 'ssab',
  SSAB_ALABAMA: 'ssab_alabama',
  BOSCH: 'bosch',
  KLABIN: 'klabin',
  SERIAL: 'serial',
  METALSA: 'metalsa',
  MIDEA: 'midea',
  VALMET: 'valmet',
  OSGT: 'osgt',
  ANDRITZ: 'andritz',
  VOLVO: 'volvo',
  TIGRE: 'tigre',
  HYUNDAI: 'hyundai',
} as const;
export type FlowType = (typeof FlowType)[keyof typeof FlowType];

export const AppAction = {
  READ: 'read',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  MANAGE: 'manage',
  APPROVE: 'approve',
  REJECT: 'reject',
  EXPORT: 'export',
  IMPORT: 'import',
  EXECUTE: 'execute',
  VIEW: 'view',
  ASSIGN: 'assign',
  UNASSIGN: 'unassign',
  PUBLISH: 'publish',
  UNPUBLISH: 'unpublish',
  ARCHIVE: 'archive',
  RESTORE: 'restore',
  COMPARE: 'compare',
  UPLOAD: 'upload',
  DOWNLOAD: 'download',
  SUBMIT: 'submit',
  CANCEL: 'cancel',
  RUN: 'run',
  STOP: 'stop',
  SCHEDULE: 'schedule',
} as const;
export type AppAction = (typeof AppAction)[keyof typeof AppAction];

export const FlowPermission = {
  NONE: 'none',
  VIEW: 'view',
  USE: 'use',
} as const;
export type FlowPermission = (typeof FlowPermission)[keyof typeof FlowPermission];

export const MainGain = {
  TIME_SAVINGS: 'time_savings',
  MONEY_SAVINGS: 'money_savings',
  QUALITY_IMPROVEMENT: 'quality_improvement',
  SECURITY_INCREASE: 'security_increase',
  OTHER: 'other',
} as const;
export type MainGain = (typeof MainGain)[keyof typeof MainGain];

export const PeriodType = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
} as const;
export type PeriodType = (typeof PeriodType)[keyof typeof PeriodType];

export const ProcessSortBy = {
  REQUESTS_DESC: 'requests_desc',
  REQUESTS_ASC: 'requests_asc',
  TOKENS_DESC: 'tokens_desc',
  TOKENS_ASC: 'tokens_asc',
  TIME_DESC: 'time_desc',
  TIME_ASC: 'time_asc',
} as const;
export type ProcessSortBy = (typeof ProcessSortBy)[keyof typeof ProcessSortBy];

export const ProcessClosingSortBy = {
  PINHO_REFERENCE_ASC: 'pinho_reference_asc',
  PINHO_REFERENCE_DESC: 'pinho_reference_desc',
  PROCESS_NUMBER_ASC: 'process_number_asc',
  PROCESS_NUMBER_DESC: 'process_number_desc',
  DATA_SLA_ASC: 'data_sla_asc',
  DATA_SLA_DESC: 'data_sla_desc',
  DATA_CONF_KPI_ASC: 'data_conf_kpi_asc',
  DATA_CONF_KPI_DESC: 'data_conf_kpi_desc',
  DATA_SOLICIT_FECHAMENTO_ASC: 'data_solicit_fechamento_asc',
  DATA_SOLICIT_FECHAMENTO_DESC: 'data_solicit_fechamento_desc',
  DATA_ENTREGA_CLIENTE_ASC: 'data_entrega_cliente_asc',
  DATA_ENTREGA_CLIENTE_DESC: 'data_entrega_cliente_desc',
  FECHAMENTO_FINANCEIRO_ASC: 'fechamento_financeiro_asc',
  FECHAMENTO_FINANCEIRO_DESC: 'fechamento_financeiro_desc',
  DATA_SOLICITACAO_DANFE_ASC: 'data_solicitacao_danfe_asc',
  DATA_SOLICITACAO_DANFE_DESC: 'data_solicitacao_danfe_desc',
} as const;
export type ProcessClosingSortBy = (typeof ProcessClosingSortBy)[keyof typeof ProcessClosingSortBy];

export const ColumnValueFilter = {
  NULL_ONLY: 'null_only',
  NOT_NULL_ONLY: 'not_null_only',
} as const;
export type ColumnValueFilter = (typeof ColumnValueFilter)[keyof typeof ColumnValueFilter];

export const Incoterm = {
  EXW: 'EXW',
  FCA: 'FCA',
  FAS: 'FAS',
  FOB: 'FOB',
  CFR: 'CFR',
  CIF: 'CIF',
  CPT: 'CPT',
  CIP: 'CIP',
  DAP: 'DAP',
  DPU: 'DPU',
  DDP: 'DDP',
} as const;
export type Incoterm = (typeof Incoterm)[keyof typeof Incoterm];

export const FeeCategory = {
  FRETE: 'frete',
  ORIGEM: 'origem',
  DESTINO: 'destino',
  OUTROS: 'outros',
} as const;
export type FeeCategory = (typeof FeeCategory)[keyof typeof FeeCategory];

export const QuotationLanguage = {
  PT: 'pt',
  EN: 'en',
} as const;
export type QuotationLanguage = (typeof QuotationLanguage)[keyof typeof QuotationLanguage];

export const QuotationFieldKind = {
  MONEY: 'money',
  DAYS: 'days',
} as const;
export type QuotationFieldKind = (typeof QuotationFieldKind)[keyof typeof QuotationFieldKind];

export const DaysPreference = {
  HIGHER: 'higher',
  LOWER: 'lower',
} as const;
export type DaysPreference = (typeof DaysPreference)[keyof typeof DaysPreference];

export const QuotationListKind = {
  ORIGEM: 'origem',
  DESTINO: 'destino',
  FORNECEDOR: 'fornecedor',
} as const;
export type QuotationListKind = (typeof QuotationListKind)[keyof typeof QuotationListKind];

export const IcmsStatus = {
  OK: 'ok',
  ATTENTION: 'attention',
  NEUTRAL: 'neutral',
} as const;
export type IcmsStatus = (typeof IcmsStatus)[keyof typeof IcmsStatus];

export const StatusMapa = {
  RETIDO: 'retido',
  LIBERADO: 'liberado',
  SEM_INFO: 'sem_info',
} as const;
export type StatusMapa = (typeof StatusMapa)[keyof typeof StatusMapa];

export const ProcessSubjectTopic = {
  GERAL: 'geral',
  DOCUMENTACAO: 'documentacao',
  TRANSPORTE: 'transporte',
  FINANCEIRO: 'financeiro',
  LPCO: 'lpco',
  CATALOGO: 'catalogo',
  ADUANEIRO: 'aduaneiro',
  PROBLEMAS: 'problemas',
} as const;
export type ProcessSubjectTopic = (typeof ProcessSubjectTopic)[keyof typeof ProcessSubjectTopic];

export const DeadlineFilter = {
  OVERDUE: 'overdue',
  TODAY: 'today',
  WEEK: 'week',
  NONE: 'none',
} as const;
export type DeadlineFilter = (typeof DeadlineFilter)[keyof typeof DeadlineFilter];

export const OccurrenceSortKey = {
  STATUS: 'status',
  PRAZO: 'prazo',
  CREATED_AT: 'created_at',
  LAST_MESSAGE_AT: 'last_message_at',
  CATEGORIA: 'categoria',
  RESPONSIBLE: 'responsible',
  TITLE: 'title',
  STAGE: 'stage',
  CREATED_BY: 'created_by',
} as const;
export type OccurrenceSortKey = (typeof OccurrenceSortKey)[keyof typeof OccurrenceSortKey];
